<template>
  <div class="signin mx-auto mt-16">
    <v-card class="mx-auto" style="max-width: 500px" outlined tile>
      <v-toolbar color="primary" cards dark flat>
        <v-card-title class="title font-weight-regular">
          <v-img
            max-height="50px"
            contain
            src="../assets/activeindoorlogocolortrans.png"
          ></v-img>
        </v-card-title>
      </v-toolbar>
      <v-form ref="form" v-model="form" class="px-4 pt-6">
        <v-text-field
          v-model="email"
          :rules="[rules.email]"
          filled
          color="primary"
          label="Email address"
          type="email"
        ></v-text-field>
        <v-text-field
          v-model="password"
          :rules="[rules.required]"
          filled
          color="primary"
          label="Password"
          type="password"
        ></v-text-field>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="$refs.form.reset()"> Clear </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="pa-0 ma-0" text @click.stop.prevent="dialog = true"
          >Forgot Password</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!form"
          :loading="isLoading"
          class="white--text"
          color="primary"
          depressed
          @click="signIn"
        >
          Sign In
        </v-btn>
      </v-card-actions>
      <v-dialog v-model="dialog" absolute max-width="500" persistent>
        <v-card outlined tile>
          <v-card-title class="headline grey lighten-3">
            Reset Password
          </v-card-title>
          <v-card-text class="py-2">
            Please enter your sign in email, we will send you a password reset
            link.
          </v-card-text>
          <v-form ref="form" v-model="form" class="px-4">
            <v-text-field
              v-model="email"
              :rules="[rules.email]"
              filled
              color="primary"
              label="Email address"
              type="email"
            ></v-text-field>
          </v-form>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text @click="dialog = false"> back </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="white--text"
              color="deep-purple accent-4"
              @click="(agreement = true), (dialog = false)"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import firebase from "../firebase.js";
export default {
  data: () => ({
    agreement: false,
    bio:
      "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts",
    dialog: false,
    email: undefined,
    form: false,
    isLoading: false,
    password: undefined,
    rules: {
      email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
      length: (len) => (v) =>
        (v || "").length >= len || `Invalid character length, required ${len}`,
      password: (v) =>
        !!(v || "").match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/
        ) ||
        "Password must contain an upper case letter, a numeric character, and a special character",
      required: (v) => !!v || "This field is required",
    },
  }),
  methods: {
    signIn() {
      if (this.email && this.password) {
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then((cred) => {
            if (cred.user) {
              this.$router.push({ name: "RealTimeStatus" });
            }
          });
      }
    },
  },
};
</script>